// 홈 화면 정적 데이터 — 힌트 칩·제안 카드 큐·미리보기 패널 등 화면에 박힌 시나리오 값 모음
import type { ProactiveItem } from '../../types';
import type {
  AttachmentPreviewData,
  HintChip,
  PostSuggestItem,
  ProActiveCardDef,
} from './Home.types';
import receiptTaxiImg from '../../assets/receipt.png';
import leaseContractImg from '../../assets/lease.png';

export const hintChips: HintChip[] = [
  { mod: 'ERP 세무',    modBg: '#FEF3C7', modColor: '#D97706', dotColor: '#F59E0B',
    menu: '부가가치세 신고',
    prompt: '8월 부가가치세 신고 메뉴로 이동해서 마감 전 점검 항목을 확인해줘' },
  { mod: 'ERP 회계',    modBg: '#EEF4FF', modColor: '#3B82F6', dotColor: '#3B82F6',
    menu: '거래처 미수금 현황',
    prompt: '거래처 미수금 현황 메뉴로 이동해서 이번 주 회수 우선순위를 보여줘' },
  { mod: 'ERP 세무',    modBg: '#FEF3C7', modColor: '#D97706', dotColor: '#F59E0B',
    menu: '전자세금계산서 확인',
    prompt: '전자세금계산서 확인 메뉴로 이동해서 미확인 건을 정리해줘' },
  { mod: 'ONEFFICE',   modBg: '#ECFDF5', modColor: '#059669', dotColor: '#10B981',
    menu: '매출 분석 보고서 작성',
    prompt: 'ONEFFICE에서 매출 분석 보고서 초안을 작성할 수 있게 메뉴로 이동해줘' },
  { mod: 'ONEFFICE',   modBg: '#ECFDF5', modColor: '#059669', dotColor: '#10B981',
    menu: 'Q3 실행계획 보고서 초안',
    prompt: 'ONEFFICE에서 지난 회의록과 매출 데이터를 바탕으로 Q3 실행계획 보고서 초안을 만들어줘' },
  { mod: 'ONEFFICE',   modBg: '#ECFDF5', modColor: '#059669', dotColor: '#10B981',
    menu: '고객사 제안서 작성',
    prompt: 'ONEFFICE에서 고객사A 제안서 템플릿을 열고 최근 자료를 반영해줘' },
  { mod: '화상회의',    modBg: '#F5F3FF', modColor: '#7C3AED', dotColor: '#7C3AED',
    menu: '고객사A 주간 점검 회의 개설',
    prompt: '화상회의에서 고객사A 주간 점검 회의를 만들고 관련 자료를 자동 첨부해줘' },
  { mod: '화상회의',    modBg: '#F5F3FF', modColor: '#7C3AED', dotColor: '#7C3AED',
    menu: '이전 회의록 AI 요약',
    prompt: '화상회의에서 어제 진행한 프로젝트 회의록 요약과 액션아이템을 확인해줘' },
  { mod: 'ONECHAMBER', modBg: '#DBEAFE', modColor: '#1D4ED8', dotColor: '#3B82F6',
    menu: '고객사A 최신 자료 찾기',
    prompt: 'ONECHAMBER에서 고객사A 관련 파일을 모아 보고서 작성에 필요한 최신본만 찾아줘' },
  { mod: 'ONECHAMBER', modBg: '#DBEAFE', modColor: '#1D4ED8', dotColor: '#3B82F6',
    menu: '공유 파일 권한 검토',
    prompt: 'ONECHAMBER에서 나와 공유된 문서 중 권한 검토가 필요한 파일을 보여줘' },
  { mod: 'ONECHAMBER', modBg: '#DBEAFE', modColor: '#1D4ED8', dotColor: '#3B82F6',
    menu: '회의자료·녹화본 문서화',
    prompt: 'ONECHAMBER에서 회의 녹화본과 첨부자료를 찾아 ONEFFICE 문서로 요약해줘' },
  { mod: '메신저',      modBg: '#F0FDF4', modColor: '#16A34A', dotColor: '#22C55E',
    menu: '보고서 리뷰 요청 공유',
    prompt: '메신저 프로젝트-알파 채널에서 보고서 초안을 공유하고 리뷰 요청 메시지를 작성해줘' },
];

/* ── 후속 힌트 칩 (Section 1) ── */
export const postHintChips: HintChip[] = [
  { mod: 'ERP 세무',  modBg: '#FEF3C7', modColor: '#D97706', dotColor: '#F59E0B',
    menu: '세금계산서 발행',
    prompt: 'ERP 세무에서 미수금 회수 완료된 3건의 세금계산서를 바로 발행해줘' },
  { mod: 'ERP 세무',  modBg: '#FEF3C7', modColor: '#D97706', dotColor: '#F59E0B',
    menu: '독촉장 초안 작성',
    prompt: 'ERP 세무에서 ㈜아사히전자 90일 초과 미수금 독촉장 초안을 작성해줘' },
  { mod: 'ONEFFICE',  modBg: '#ECFDF5', modColor: '#059669', dotColor: '#10B981',
    menu: '거래처 미팅 보고서 첨부',
    prompt: 'ONEFFICE에서 이번 주 거래처 미팅 자료를 자동 첨부하고 보고서로 정리해줘' },
  { mod: 'ONEFFICE',  modBg: '#ECFDF5', modColor: '#059669', dotColor: '#10B981',
    menu: '미수금 현황 보고서 공유',
    prompt: 'ONEFFICE에서 오늘 작성한 미수금 현황 보고서를 팀장님께 공유해줘' },
  { mod: '화상회의',  modBg: '#F5F3FF', modColor: '#7C3AED', dotColor: '#7C3AED',
    menu: '거래처 미팅 일정 개설',
    prompt: '화상회의에서 ㈜아사히전자와 미수금 협의를 위한 화상 미팅을 개설하고 안건을 첨부해줘' },
  { mod: '화상회의',  modBg: '#F5F3FF', modColor: '#7C3AED', dotColor: '#7C3AED',
    menu: '이전 협의 회의록 요약',
    prompt: '화상회의에서 ㈜아사히전자와 진행한 지난 협의 회의록을 AI로 요약해줘' },
];


export const postResponseSuggestions: PostSuggestItem[] = [
  {
    id: 101,
    title: '세금계산서 자동 발행',
    metaType: 'date',
    metaLabel: '마감일',
    metaDate: '2025.08.31 (일)',
    desc: '미수금 회수 완료 후 3건의 세금계산서 발행이 필요해요.\nERP 세무에서 바로 처리할 수 있어요.',
    actionLabel: '발행하기',
    actionStyle: 'solid',
  },
  {
    id: 102,
    title: '독촉장 발송 대상 안내',
    metaType: 'warn',
    desc: '㈜아사히전자 90일 초과 미수금에 대한\n독촉장 발송을 권장해요.',
    actionLabel: '초안 보기',
    actionStyle: 'outline',
  },
  {
    id: 103,
    title: '거래처 미팅 자료 준비',
    metaType: null,
    desc: '이번 주 예정된 거래처 미팅에\nONEFFICE 보고서를 자동 첨부할 수 있어요.',
    actionLabel: '준비하기',
    actionStyle: 'outline',
  },
];

/* ── 거래처/AI 추천 조치 목록의 상태 배지 색상 매핑 (AXStatusBadge 색상 override) ── */
export const AR_STATUS_STYLE: Record<'stOverdue' | 'stWarning' | 'stProgress', { tone: 'overdue' | 'warning' | 'progress'; background: string; textColor: string }> = {
  stOverdue:  { tone: 'overdue',  background: '#FEE2E2', textColor: '#DC2626' },
  stWarning:  { tone: 'warning',  background: '#FEF3C7', textColor: '#D97706' },
  stProgress: { tone: 'progress', background: '#D1FAF0', textColor: '#059669' },
};


/* ── 리스 상환 스케줄 데이터 (실효이자율(EIR) 기준) ──
   [회차, 지급일, 기초 리스채무, 이자비용, 리스채무 상환(원금), 월 리스료(세전), 소비세, 현금지급, 기말 리스채무] */
export const REPAYMENT_SCHEDULE_DATA: [number, string, number, number, number, number, number, number, number][] = [
  [1, "2026-06-03", 907700, 3363, 13537, 16900, 1690, 18590, 894163],
  [2, "2026-07-03", 894163, 3313, 13587, 16900, 1690, 18590, 880576],
  [3, "2026-08-03", 880576, 3263, 13637, 16900, 1690, 18590, 866939],
  [4, "2026-09-03", 866939, 3212, 13688, 16900, 1690, 18590, 853251],
  [5, "2026-10-03", 853251, 3161, 13739, 16900, 1690, 18590, 839512],
  [6, "2026-11-03", 839512, 3110, 13790, 16900, 1690, 18590, 825722],
  [7, "2026-12-03", 825722, 3059, 13841, 16900, 1690, 18590, 811881],
  [8, "2027-01-03", 811881, 3008, 13892, 16900, 1690, 18590, 797989],
  [9, "2027-02-03", 797989, 2957, 13943, 16900, 1690, 18590, 784046],
  [10, "2027-03-03", 784046, 2905, 13995, 16900, 1690, 18590, 770051],
  [11, "2027-04-03", 770051, 2853, 14047, 16900, 1690, 18590, 756004],
  [12, "2027-05-03", 756004, 2801, 14099, 16900, 1690, 18590, 741905],
  [13, "2027-06-03", 741905, 2749, 14151, 16900, 1690, 18590, 727754],
  [14, "2027-07-03", 727754, 2696, 14204, 16900, 1690, 18590, 713550],
  [15, "2027-08-03", 713550, 2644, 14256, 16900, 1690, 18590, 699294],
  [16, "2027-09-03", 699294, 2591, 14309, 16900, 1690, 18590, 684985],
  [17, "2027-10-03", 684985, 2538, 14362, 16900, 1690, 18590, 670623],
  [18, "2027-11-03", 670623, 2485, 14415, 16900, 1690, 18590, 656208],
  [19, "2027-12-03", 656208, 2431, 14469, 16900, 1690, 18590, 641739],
  [20, "2028-01-03", 641739, 2378, 14522, 16900, 1690, 18590, 627217],
  [21, "2028-02-03", 627217, 2324, 14576, 16900, 1690, 18590, 612641],
  [22, "2028-03-03", 612641, 2270, 14630, 16900, 1690, 18590, 598011],
  [23, "2028-04-03", 598011, 2216, 14684, 16900, 1690, 18590, 583327],
  [24, "2028-05-03", 583327, 2161, 14739, 16900, 1690, 18590, 568588],
  [25, "2028-06-03", 568588, 2107, 14793, 16900, 1690, 18590, 553795],
  [26, "2028-07-03", 553795, 2052, 14848, 16900, 1690, 18590, 538947],
  [27, "2028-08-03", 538947, 1997, 14903, 16900, 1690, 18590, 524044],
  [28, "2028-09-03", 524044, 1942, 14958, 16900, 1690, 18590, 509086],
  [29, "2028-10-03", 509086, 1886, 15014, 16900, 1690, 18590, 494072],
  [30, "2028-11-03", 494072, 1831, 15069, 16900, 1690, 18590, 479003],
  [31, "2028-12-03", 479003, 1775, 15125, 16900, 1690, 18590, 463878],
  [32, "2029-01-03", 463878, 1719, 15181, 16900, 1690, 18590, 448697],
  [33, "2029-02-03", 448697, 1662, 15238, 16900, 1690, 18590, 433459],
  [34, "2029-03-03", 433459, 1606, 15294, 16900, 1690, 18590, 418165],
  [35, "2029-04-03", 418165, 1549, 15351, 16900, 1690, 18590, 402814],
  [36, "2029-05-03", 402814, 1492, 15408, 16900, 1690, 18590, 387406],
  [37, "2029-06-03", 387406, 1435, 15465, 16900, 1690, 18590, 371941],
  [38, "2029-07-03", 371941, 1378, 15522, 16900, 1690, 18590, 356419],
  [39, "2029-08-03", 356419, 1321, 15579, 16900, 1690, 18590, 340840],
  [40, "2029-09-03", 340840, 1263, 15637, 16900, 1690, 18590, 325203],
  [41, "2029-10-03", 325203, 1205, 15695, 16900, 1690, 18590, 309508],
  [42, "2029-11-03", 309508, 1147, 15753, 16900, 1690, 18590, 293755],
  [43, "2029-12-03", 293755, 1088, 15812, 16900, 1690, 18590, 277943],
  [44, "2030-01-03", 277943, 1030, 15870, 16900, 1690, 18590, 262073],
  [45, "2030-02-03", 262073, 971, 15929, 16900, 1690, 18590, 246144],
  [46, "2030-03-03", 246144, 912, 15988, 16900, 1690, 18590, 230156],
  [47, "2030-04-03", 230156, 853, 16047, 16900, 1690, 18590, 214109],
  [48, "2030-05-03", 214109, 793, 16107, 16900, 1690, 18590, 198002],
  [49, "2030-06-03", 198002, 734, 16166, 16900, 1690, 18590, 181836],
  [50, "2030-07-03", 181836, 674, 16226, 16900, 1690, 18590, 165610],
  [51, "2030-08-03", 165610, 614, 16286, 16900, 1690, 18590, 149324],
  [52, "2030-09-03", 149324, 553, 16347, 16900, 1690, 18590, 132977],
  [53, "2030-10-03", 132977, 493, 16407, 16900, 1690, 18590, 116570],
  [54, "2030-11-03", 116570, 432, 16468, 16900, 1690, 18590, 100102],
  [55, "2030-12-03", 100102, 371, 16529, 16900, 1690, 18590, 83573],
  [56, "2031-01-03", 83573, 310, 16590, 16900, 1690, 18590, 66983],
  [57, "2031-02-03", 66983, 248, 16652, 16900, 1690, 18590, 50331],
  [58, "2031-03-03", 50331, 186, 16714, 16900, 1690, 18590, 33617],
  [59, "2031-04-03", 33617, 125, 16775, 16900, 1690, 18590, 16842],
  [60, "2031-05-03", 16842, 62, 16842, 16904, 1690, 18594, 0],
];

export const repayFmt = (n: number) => '¥' + n.toLocaleString('ja-JP');

export const ATTACHMENT_PREVIEWS: Record<string, AttachmentPreviewData> = {
  receipt: {
    kicker: '첨부 파일 · 영수증 원본',
    fileName: '출장비영수증.PNG',
    fileType: 'PNG 이미지',
    img: receiptTaxiImg,
    meta: [
      { label: '거래처', value: '北星タクシー株式会社' },
      { label: '거래일', value: '2026-03-19' },
      { label: '금액', value: '¥1,200' },
    ],
    detail: [
      { label: '공급가액', value: '¥1,091' },
      { label: '소비세(10%)', value: '¥109' },
      { label: '인보이스 번호', value: 'T4430001062785' },
    ],
  },
  lease: {
    kicker: '첨부 파일 · 리스 계약서',
    fileName: '리스 계약서.PNG',
    fileType: 'PNG 이미지',
    img: leaseContractImg,
    meta: [
      { label: '거래처', value: '株式会社 大塚商会' },
      { label: '계약기간', value: '2026-06-01 ~ 2031-05-31' },
      { label: '계약 금액', value: '¥907,700' },
    ],
    detail: [
      { label: '계약 번호', value: 'BY8210610' },
      { label: '리스회사', value: '三井住友トラスト・パナソニックファイナンス' },
      { label: '담당자', value: '高橋 ひより 様' },
    ],
  },
};

/* ── 전표 전송 완료 후 [전표 입력 바로가기] 이동 경로 (시나리오별 ERP 전표입력 화면) ──
   ?picked=1: ProActive 제안을 통해 진입 → AI가 제안한 전표 행만 체크된 상태로 표시 */
export const JOURNAL_LINK_PATH: Record<string, string> = {
  'lease-journal': '/erp/lease?picked=1',
  'invoice-journal': '/erp/mail-invoice',
  'receipt-journal': '/erp/evidence',
  'natural-journal': '/erp/natural-revised',
};

/** 턴당 이미지 장수 — 토큰 비용이 장수에 비례해서 붙는다 */
export const MAX_CHAT_IMAGES = 3;

/** 이미지를 몇 턴까지 함께 보낼지 — 이후는 색인된 전사 텍스트가 검색으로 답한다 */
export const IMAGE_TURN_LIMIT = 2;

/* ── ProActive 카드 전체 큐 (전체 표시, 제한 없음) ── */
export const DISPLAY_LIMIT = Infinity;

export const PROACTIVE_CARD_QUEUE: ProActiveCardDef[] = [
  /* ── 표시 영역 (1~6번) ── */
  {
    id: 'mou-mail',
    title: 'MOU 요청 메일 대응',
    kicker: '오늘 처리 추천',
    iconType: 'mail',
    metaType: 'none',
    metaText: '',
    desc: '일본 파트너사가 MOU 초안과 레퍼런스 자료를 요청했습니다.',
    actionLabel: '처리하기',
    actionStyle: 'solid',
    secondaryAction: 'mail-source',
    prompt: '파트너사 긴급 메일 내용을 먼저 브리핑해줘',
  },
   {
    id: 'ar-report',
    title: '월간 실적 리포트 점검',
    kicker: '업무 후보',
    iconType: 'chart',
    metaType: 'none',
    metaText: '',
    desc: '매출 증감과 주요 이슈를 정리해 보고서 작성 흐름으로 연결할 수 있습니다.',
    actionLabel: '확인하기',
    actionStyle: 'outline',
    prompt: '이번주 ERP 회계에서 미수금이 있는 거래처를 정리하고, ONEFFICE 보고서로 만들어줘',
  },
  {
    id: 'lease-journal',
    title: '리스료 전표 반영',
    kicker: '분개확인',
    iconType: 'document',
    metaType: 'none',
    metaText: '',
    desc: '복합기 리스에 대한 분개를 생성하였습니다. 분개를 확인후 전표로 반영해주세요.',
    actionLabel: '확인하기',
    actionStyle: 'outline',
    prompt: '오늘 납부할 리스료가 있는지 확인하고 회계 처리 방식에 맞춰서 분개를 만들어줘',
  },
  
 
  {
    id: 'invoice-journal',
    title: '인보이스 전표 반영',
    kicker: '',
    iconType: 'calendar',
    metaType: 'warn',
    metaText: '확인 필요',
    desc: '株式会社ニトリ에서 전송한청구서로 전표를 생성하였습니다.생성된 전표를 확인해주세요.',
    actionLabel: '확인하기',
    actionStyle: 'outline',
    prompt: '이메일 첨부파일을 확인하여 증빙 여부를 판단하고, 증빙인 경우 전표를 생성해 주세요.',
  },
  {
    id: 'evidence-mapping',
    title: '수임기업 증빙 파일 전표 반영',
    kicker: '세무 처리',
    iconType: 'document',
    metaType: 'warn',
    metaText: '확인 필요',
    desc: '제노랩으로부터 수신한 증빙 파일을 전표에 자동 매핑하였습니다.',
    actionLabel: '확인하기',
    actionStyle: 'outline',
    prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘',
  },
  
  {
    id: 'tax',
    title: '세금계산서 자동 발행',
    kicker: '마감 임박',
    iconType: 'document',
    metaType: 'date',
    metaText: '마감일 2025.08.31 (일)',
    desc: '정기적인 거래처 3곳의 세금계산서 발행이 필요해요.',
    actionLabel: '발행하기',
    actionStyle: 'outline',
    prompt: 'ERP 세무에서 미수금 회수 완료된 3건의 세금계산서를 자동 발행해줘',
  },
  {
    id: 'dunning',
    title: '미수금 독촉장 초안',
    kicker: '업무 후보',
    iconType: 'document',
    metaType: 'date',
    metaText: '생성일 2025.08.25 (월)',
    desc: '3개 거래처에 발송할 독촉장 초안을 AI가 작성했어요.',
    actionLabel: '확인하기',
    actionStyle: 'outline',
    prompt: 'ERP 세무에서 미수금 독촉장 초안을 확인하고 발송을 준비해줘',
  },
  /* ── 예비 영역 (7번~, 카드가 하나씩 실행될 때마다 순서대로 보충됨) ── */
  {
    id: 'credit',
    title: '거래처 신용 위험 분석',
    kicker: '위험 감지',
    iconType: 'warning',
    metaType: 'warn',
    metaText: '확인 필요',
    desc: '연체 중인 ㈜아사히 전자의 신용 위험이 상승했어요.',
    actionLabel: '분석 보기',
    actionStyle: 'outline',
    prompt: '㈜아사히전자 신용 위험 분석 결과를 보여줘',
  },
  {
    id: 'tax-report',
    title: '7월 세무신고 — D-3',
    kicker: '마감 임박',
    iconType: 'calendar',
    metaType: 'date',
    metaText: '마감일 2026.7.10 (일)',
    desc: '6월 원천세 신고가 3일 남았습니다. 미완료 거래처를 확인하세요.',
    actionLabel: '신고 확인',
    actionStyle: 'solid',
    prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘',
  },
  
  {
    id: 'meeting',
    title: '회의 액션 아이템 확인',
    kicker: '후속 정리',
    iconType: 'chat',
    metaType: 'none',
    metaText: '',
    desc: '최근 회의록에서 담당자 미지정 액션과 공유 자료 확인 항목을 감지했습니다.',
    actionLabel: '회의 보기',
    actionStyle: 'outline',
    prompt: '6월 영업전략 회의 준비 흐름을 정리하고, 누락된 자료와 다음 실행 항목을 제안해줘',
  },

  {
    id: 'circular',
    title: '법인카드 규정 개정 회람',
    kicker: '내부 공지',
    iconType: 'document',
    metaType: 'warn',
    metaText: '확인 필요 · 회람 5/9',
    desc: '법인카드 사용 규정 개정 안내가 일부 부서에서 멈춰 있어요.',
    actionLabel: '회람 확인',
    actionStyle: 'outline',
    prompt: '법인카드 사용 규정 개정 업무 흐름을 정리하고, 회람 지연 대상과 다음 실행 항목을 제안해줘',
  },
   {
    id: 'followup',
    title: '공유 문서 최신본 확인',
    kicker: '문서 관리',
    iconType: 'document',
    metaType: 'none',
    metaText: '',
    desc: 'ONECHAMBER 공유 파일 중 검토가 필요한 최신 문서 후보가 있습니다.',
    actionLabel: '문서 보기',
    actionStyle: 'outline',
    prompt: '하계 유연근무제 안내 업무 흐름을 정리하고, 누락된 조치와 다음 실행 항목을 제안해줘',
  },
  /* 여기에 예비 카드를 계속 추가하면 자동으로 큐에 쌓임 */
];

/* 초기 표시 카드: 큐 전체 */
export const INITIAL_PROACTIVE_CARDS = PROACTIVE_CARD_QUEUE.slice();

/* ── API ProactiveItem → ProActiveCardDef 변환 ── */
export const PROACTIVE_ID_KEY: Record<number, string> = { 1: 'meeting', 2: 'followup', 3: 'circular' };
export const PROACTIVE_PROMPTS: Record<string, string> = {
  meeting:          '6월 영업전략 회의 준비 흐름을 정리하고, 누락된 자료와 다음 실행 항목을 제안해줘',
  followup:         '하계 유연근무제 안내 업무 흐름을 정리하고, 누락된 조치와 다음 실행 항목을 제안해줘',
  circular:         '법인카드 사용 규정 개정 업무 흐름을 정리하고, 회람 지연 대상과 다음 실행 항목을 제안해줘',
};

export function mapProactiveItems(items: ProactiveItem[]): ProActiveCardDef[] {
  /* API 응답을 id → 카드 맵으로 변환 */
  const apiMap = new Map<string, ProActiveCardDef>();
  items.forEach(item => {
    const key = PROACTIVE_ID_KEY[item.id] ?? 'custom';
    const metaType: ProActiveCardDef['metaType'] =
      item.metaType === 'date' ? 'date' : item.metaType === 'warn' ? 'warn' : 'none';
    const metaText =
      metaType === 'date'
        ? `${item.metaLabel ?? ''} ${item.metaDate ?? ''}`.trim()
        : metaType === 'warn'
        ? item.metaWarnLabel ?? ''
        : '';
    apiMap.set(key, {
      id: key,
      title: item.title ?? '',
      metaType,
      metaText,
      desc: item.desc ?? '',
      actionLabel: item.actionLabel ?? '실행',
      actionStyle: item.actionStyle ?? 'outline',
      prompt: PROACTIVE_PROMPTS[key] ?? `${item.title ?? ''} 업무 흐름을 정리해줘`,
    });
  });
  /* 큐 순서를 유지하면서 API 카드가 있으면 내용을 교체 */
  return PROACTIVE_CARD_QUEUE.map(qCard => apiMap.get(qCard.id) ?? qCard);
}


/* ── 문서 미리보기 패널 데이터 ── */
export const DOC_PREVIEWS = [
  {
    type: 'ONEX',
    title: '[템플릿] 글로벌 AI 제휴 표준 MOU 양식.onex',
    path: 'ONECHAMBER / 법무·계약 / MOU 양식',
    author: '법무팀 · 이준호 과장',
    date: '2026.03.15',
    size: '124KB',
    match: 96,
    keywords: ['양사 역할 범위', 'PoC 추진 방식', '데이터 주권'],
    aiReason: '이 메일에서 요청한 MOU 초안 항목과 조항 구성이 96% 일치합니다. "양사 역할 범위", "PoC 추진 방식", "데이터 주권" 항목이 메일 본문 요구사항과 직접 매핑되며, 법무팀이 검토 완료한 공식 양식입니다.',
    overview: '국내외 기업 간 기술·사업 협력 시 활용 가능한 표준 MOU 양식입니다. 법무팀 검토를 거쳐 작성된 공식 문서로, 목적·역할·기밀유지·유효기간 등 핵심 조항이 포함되어 있습니다.',
    overviewBullets: [
      '국내외 AI 파트너십 체결 시 표준 적용 가능',
      '법무팀 3차 검토 완료 (2026.03.15)',
      '일본어 번역본 별도 첨부 가능',
      '전자계약 시스템 연동 지원',
    ],
    tableTitle: '포함 조항 구성',
    tableHeaders: ['조항', '제목', '주요 내용'],
    tableRows: [
      ['제1조', '협력 목적 및 범위', '양사 간 AI 기술·사업 협력의 목적과 적용 범위 정의'],
      ['제2조', '양사 역할 및 책임 분담', '각사의 역할, 의무, 책임 한계 명시'],
      ['제3조', '기밀유지 의무', '기술 정보·고객 데이터·계약 내용의 비공개 의무'],
      ['제4조', '지적재산권 귀속', '공동 개발 결과물의 IP 귀속 및 활용 범위'],
      ['제5조', '유효기간 및 해지', '계약 유효기간, 자동 갱신 조건, 해지 절차'],
      ['제6조', '분쟁 해결', '준거법, 관할 법원, 조정 절차'],
    ],
  },
  {
    type: 'PDF',
    title: '[기획안] 2026 Sovereign AI 비즈니스 전략 기획서.pdf',
    path: 'ONECHAMBER / 전략기획 / 2026년도',
    author: 'DX혁신팀 · 문서진 팀장',
    date: '2026.04.22',
    size: '3.8MB',
    match: 91,
    keywords: ['회계·세무 자동화', '데이터 주권', '일본 시장 전략'],
    aiReason: '메일 발신자(Tokyo Strategic Partners)의 사업 모델과 이 기획서의 일본 파트너십 전략이 91% 유사합니다. "회계·세무 자동화"와 "데이터 주권" 니즈가 일치하며, MOU 협력 방향 설정에 직접 활용할 수 있습니다.',
    overview: '2026년 Sovereign AI 사업 전략 방향을 정의한 내부 기획서입니다. 일본 시장 진출 전략, 데이터 주권 아키텍처, 규제 대응 방안이 포함되어 있습니다.',
    overviewBullets: [
      '일본 금융·제조·공공 3대 핵심 타깃 정의',
      '데이터 주권 아키텍처 5가지 원칙 수립',
      '파트너십 수익 배분 모델 3가지 시나리오',
      '2026년 하반기 PoC 일정 및 KPI 포함',
    ],
    tableTitle: '주요 목차',
    tableHeaders: ['챕터', '내용'],
    tableRows: [
      ['Chapter 1', 'Sovereign AI 시장 분석 — 일본·동남아 중심'],
      ['Chapter 2', '데이터 주권 아키텍처 설계 원칙'],
      ['Chapter 3', '일본 금융·제조 고객 타깃 전략'],
      ['Chapter 4', '파트너십 모델 및 수익 구조'],
      ['Chapter 5', '2026년 로드맵 및 KPI'],
    ],
  },
  {
    type: 'PPTX',
    title: '[설계서] 일본 시장 로컬라이제이션 기술 사양서.pptx',
    path: 'ONECHAMBER / 기술문서 / 해외사업',
    author: '개발팀 · 김태영 선임',
    date: '2026.05.10',
    size: '8.2MB',
    match: 87,
    keywords: ['보안·컴플라이언스', '일본 데이터센터', 'APPI 준수'],
    aiReason: '메일에서 요청한 "보안·데이터 주권 관련 설명자료"와 87% 일치합니다. 컴플라이언스 기준 및 일본 내 데이터 보관 조건이 명시되어 있어 MOU 3조(데이터 보관 위치·보안 기준) 초안에 직접 인용 가능합니다.',
    overview: '일본 시장 진출을 위한 플랫폼 기술 로컬라이제이션 요건을 정의한 문서입니다. APPI 준수, 일본어 UI, 일본 데이터센터 연동 등 기술 사양이 담겨 있습니다.',
    overviewBullets: [
      '일본 개인정보보호법(APPI) 전면 준수 설계',
      '도쿄·오사카 리전 이중화 구성',
      '금융청 감사 로그 요건 5년 보관 지원',
      '일본어 UI 현지화 진행률 92%',
    ],
    tableTitle: '기술 요건 요약',
    tableHeaders: ['항목', '요건', '상태'],
    tableRows: [
      ['데이터 보관', '일본 국내 IDC 전용 서버', 'done'],
      ['개인정보', 'APPI 제20·21조 준수', 'done'],
      ['UI 현지화', '일본어 풀 지원', 'progress'],
      ['금융청 규제', '감사 로그 5년 보관', 'done'],
      ['암호화', 'AES-256 저장·전송 암호화', 'done'],
    ],
  },
];

/* DISPLAY_CARD_IDS 제거 — 큐 방식으로 currentProActiveCards가 항상 표시 목록 */

/* ── 섹션 설정 ── */
export const DURATION = 460;
